import { useEffect } from "react";

/**
 * Imperative per-page SEO: updates <title> and <meta name="description">.
 * Restores previous values on unmount so cached page state stays sane.
 */
export function useSeo({ title, description }) {
  useEffect(() => {
    const prevTitle = document.title;
    const meta = document.querySelector('meta[name="description"]');
    const prevDesc = meta ? meta.getAttribute("content") : null;

    if (title) document.title = title;
    if (meta && description) meta.setAttribute("content", description);

    return () => {
      document.title = prevTitle;
      if (meta && prevDesc !== null) meta.setAttribute("content", prevDesc);
    };
  }, [title, description]);
}
